import { createFileRoute, redirect } from '@tanstack/react-router';
import { isXeroEnabled } from '@/lib/feature-flags';
import { FinanceGuard } from '@/components/finance/FinanceGuard';
import { ReportsView } from '@/components/finance/ReportsView';

/**
 * /finance/reports — Reports area (F-013 S7). Real + flag-gated route (path/guard unchanged). A P&L
 * summary + monthly trend table over the org's REAL synced snapshots, with CSV export. Balance Sheet
 * and Cash Flow statements follow once Phase A cash decomposition lands (ticket 86d43w13a).
 */
export const Route = createFileRoute('/finance/reports')({
  beforeLoad: () => {
    if (!isXeroEnabled()) {
      throw redirect({ to: '/finance', replace: true });
    }
  },
  component: () => (
    <FinanceGuard>
      <ReportsView />
    </FinanceGuard>
  ),
});
